import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from '../ui/carousel';
import HeroBanner from './HeroBanner';
import MasterClassPromoSlide from './MasterClassPromoSlide';

const AUTOPLAY_MS = 7000;

const HeroCarousel: React.FC = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [slideCount, setSlideCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    setSlideCount(api.scrollSnapList().length);
    setSelectedIndex(api.selectedScrollSnap());

    const onSelect = () => setSelectedIndex(api.selectedScrollSnap());
    api.on('select', onSelect);
    return () => {
      api.off('select', onSelect);
    };
  }, [api]);

  useEffect(() => {
    if (!api) return;
    const interval = window.setInterval(() => {
      api.scrollNext();
    }, AUTOPLAY_MS);
    return () => window.clearInterval(interval);
  }, [api]);

  return (
    <div className="group relative">
      <Carousel setApi={setApi} opts={{ loop: true }} className="overflow-hidden">
        <CarouselContent className="-ml-0">
          <CarouselItem className="pl-0">
            <HeroBanner />
          </CarouselItem>
          <CarouselItem className="pl-0">
            <MasterClassPromoSlide />
          </CarouselItem>
        </CarouselContent>
      </Carousel>

      {/* Flechas */}
      <button
        onClick={() => api?.scrollPrev()}
        aria-label="Slide anterior"
        className="absolute left-4 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/10 p-2 text-white opacity-0 backdrop-blur-md transition-all duration-300 hover:bg-white/20 group-hover:opacity-100 md:left-6"
      >
        <ChevronLeft size={22} />
      </button>
      <button
        onClick={() => api?.scrollNext()}
        aria-label="Siguiente slide"
        className="absolute right-4 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/10 p-2 text-white opacity-0 backdrop-blur-md transition-all duration-300 hover:bg-white/20 group-hover:opacity-100 md:right-6"
      >
        <ChevronRight size={22} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 z-20 flex -translate-x-1/2 gap-2">
        {Array.from({ length: slideCount }).map((_, index) => (
          <button
            key={index}
            onClick={() => api?.scrollTo(index)}
            aria-label={`Ir al slide ${index + 1}`}
            className={`h-2 rounded-full transition-all duration-300 ${
              index === selectedIndex ? 'w-8 bg-infinity-yellow' : 'w-2 bg-white/40 hover:bg-white/60'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
